<template >
  <div class="new-home-service">
    <h2 v-if="isDesktop">Testachats, à votre service</h2>
      <br v-if="isMobile">
    <div class="icons">
      <div class="icon-container" style="margin: 0 10px 0 0;">
        <img src="/images/nl_new_home/Atom/Icon/65ans.png" alt="" width="58px" height="58px"/>
          <h3>Plus de 65 ans</h3>
        <p class="text-uppercase">d'expertise</p>
      </div>
      <div class="icon-container association">
        <img src="/images/nl_new_home/Atom/Icon/belgium.png"  width="58px" height="58px" />
          <h3>1<sup>re</sup></h3>
        <p class="text-uppercase">association de <br v-if="isDesktop">consommateurs <br> en Belgique</p>
      </div>
      <div class="icon-container independant" >
        <img src="/images/nl_new_home/Atom/Icon/trust.png"  alt="" width="58" height="58"  />
        <h3 style="margin-top: 2px;">Indépendant</h3>
        <p class="text-uppercase">de tout lobby et <br class="mobile_hide">de toute enseigne</p>
      </div>
    </div>

    <p class="description line-height">
      Testachats est une association qui a pour objectif d'informer, de
      défendre et de représenter les consommateurs en Belgique. Nous sommes
      <strong>indépendants</strong> de toute influence politique ou économique.
      C’est pourquoi notre abonnement vous donne
      <strong>un pack d’avantages membres
      vous permettant de faire des économies, de vous protéger et d’en apprendre plus sur des sujets
        variés.</strong>
    </p>
    <img class="open-box" :src="service_image" alt="" />
    <img class="open-box-m" :src="service_image_mobile" alt="" />
  </div>
</template>
<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin";

export default {
    mixins:[image_mixin],
    computed: {
        isMobile() {
            return window.innerWidth <= 768;
        },
        isDesktop() {
            return !this.isMobile;
        },
    }
};
</script>
